import React, { StrictMode } from 'react';
import ReactDOM from "react-dom";
import i18n from "i18next";
import { PostHogProvider } from 'posthog-js/react';
import { I18nextProvider, initReactI18next } from "react-i18next";

import App from "./App";
import { ReactHintFactory } from "./components/Global/ToolTip";
// import { setToken } from "./configuration/axiosDefaults";
import DetectInternet from "./components/Global/DetectInternet";
import enTranslation from "./translate/en.json";
import esTranslation from "./translate/es.json";
import jaTranslation from "./translate/ja.json";
import trTranslation from "./translate/tr.json";
import arTranslation from "./translate/ar.json";
import zh_cnTranslation from "./translate/zh-cn.json";
import rusTranslation from "./translate/rus.json";
import deTranslation from "./translate/de.json";
import frTranslation from "./translate/fr.json";
import nlTranslation from "./translate/nl.json";
import hiTranslation from "./translate/hi.json";
import urTranslation from "./translate/ur.json";
import koTranslation from "./translate/ko.json";
import kkTranslation from "./translate/kk.json";
import azTranslation from "./translate/az.json";
import uzTranslation from "./translate/uz.json";
import itTranslation from "./translate/it.json";
import svTranslation from "./translate/sv.json";
import ptBrTranslation from "./translate/pt-br.json";
import enZaTranslation from "./translate/en-za.json";
import bnTranslation from "./translate/bn.json";
import { DEFAULT_PRIMARY_LANGUAGE, getStoredUserLanguage } from "./utils/appLanguages";

import "./resources/scss/styles.scss";
import "./resources/css/r-hint.css";
import "./resources/css/theme.css";
import "semantic-ui-css/semantic.min.css";

// Import iframe protection utility to prevent malicious iframe injection
import "./utils/iframeProtection";
// Import iframe diagnostics to help identify the source (only in development)
import "./utils/iframeDiagnostics";

const ReactHint = ReactHintFactory(React);

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: {
    $created_at: new Date().toISOString(),
  },
  persistence: "localStorage+cookie",
};

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const initialLanguage = getStoredUserLanguage() || DEFAULT_PRIMARY_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    es: { translation: esTranslation },
    ja: { translation: jaTranslation },
    tr: { translation: trTranslation },
    ar: { translation: arTranslation },
    zh_cn: { translation: zh_cnTranslation },
    rus: { translation: rusTranslation },
    de: { translation: deTranslation },
    fr: { translation: frTranslation },
    nl: { translation: nlTranslation },
    hi: { translation: hiTranslation },
    ur: { translation: urTranslation },
    ko: { translation: koTranslation },
    kk: { translation: kkTranslation },
    az: { translation: azTranslation },
    uz: { translation: uzTranslation },
    it: { translation: itTranslation },
    sv: { translation: svTranslation },
    pt_br: { translation: ptBrTranslation },
    en_za: { translation: enZaTranslation },
    bn: { translation: bnTranslation },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_PRIMARY_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});



const appContent = (
  <I18nextProvider i18n={i18n}>
    <div className="h-100">
      <ReactHint events delay={1000} />
      <DetectInternet>
        <App />
      </DetectInternet>
    </div>
  </I18nextProvider>
);

const RootApp = () => {
  return (
    <StrictMode>
      {isLocalhost ? (
        appContent
      ) : (
        <PostHogProvider
          apiKey={process.env.REACT_APP_POSTHOG_KEY}
          options={posthogOptions}
        >
          {appContent}
        </PostHogProvider>
      )}
    </StrictMode>
  );
};

ReactDOM.render(<RootApp />, document.getElementById("root"));